import { render, staticRenderFns } from "./month_expense.vue?vue&type=template&id=7cb1f61a&"
import script from "./month_expense.vue?vue&type=script&lang=ts&"
export * from "./month_expense.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports